import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import { DateCell } from '../../../../utils/Cells';
import * as dateUtil from '../../../common/filters/DateUtil';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';

const f = new Intl.DateTimeFormat('hu');

class Name extends Component {
    fields = ['name', 'validFrom'];

    state = {
        customerId: this.props.row.privateId,
        names: [],
        name: "",
        validFrom: new Date(),
        errors: new Map(),
        first: {}
    };

    componentDidMount() {
        console.log(this.props.row);
        this.callNameApi(this.props.row.privateId)
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    enrich = (data) => {
        data.map((item) => {
            item.validFromDate = (item.validFrom) ? f.format(new Date(item.validFrom)) : "";
            item.validUntilDate = (item.validUntil) ? f.format(new Date(item.validUntil)) : "";
            return item;
        })
        let firstElement = data.splice(0, 1).pop();
        if (firstElement) {
            this.setState({ first: firstElement });
        }
        this.setState({ names: data })
    }

    callNameApi = async (id) => {
        const path = `/api/customer/name/${id}`;
        const response = await axios.get(path);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/customer/name';
        const requestObject = {
            "customerId": this.state.customerId,
            "name": this.state.name,
            "validFrom": this.state.validFrom
        };
        await handlePost(path, requestObject, this);
    };

    handleNameChange = (e, this2) => {
        if (e.target && e.target.value && this.state.first.privateId) {
            const newValidUntil = dateUtil.getYesterday(new Date(this.state.validFrom));
            let m = this.state.first;
            m.validUntil = newValidUntil;
            m.validUntilDate = f.format(newValidUntil);
            this.setState({ first: m });
        }
        handleChangeEvent(e, this2);
    }

    handleValidUntilChange = (e) => {
        if (this.state.name && this.state.first.privateId) {
            const newValidUntil = dateUtil.getYesterday(e);
            let m = this.state.first;
            m.validUntil = newValidUntil;
            m.validUntilDate = f.format(newValidUntil);
            this.setState({ first: m });
        }
        this.setState({ validFrom: e });
    }

    getMinDate = () => {
        if (this.state.first.validFrom) {
            return dateUtil.getTomorrow(new Date(this.state.first.validFrom));
        }
    }

    getClass = () => {
        if (this.state.name) {
            return "newly-added";
        } else {
            return "";
        }
    }

    getBody() {
        return (
            <TableBody>
                {(this.state.name) ?
                    <TableRow key="new" className="newly-added">
                        <TableCell > {this.state.name}</TableCell>
                        <TableCell align="right"><DateCell value={this.state.validFrom} /></TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                    : <></>}
                {(this.state.first) ?
                    <TableRow key={this.state.first.privateId}>
                        <TableCell > {this.state.first.name}</TableCell>
                        <TableCell align="right">{this.state.first.validFromDate}</TableCell>
                        <TableCell align="right" className={this.getClass()}>{this.state.first.validUntilDate}</TableCell>
                    </TableRow>
                    : <></>}
                {this.state.names.map((row) => (
                    <TableRow key={row.privateId} >
                        <TableCell > {row.name}</TableCell>
                        <TableCell align="right">{row.validFromDate}</TableCell>
                        <TableCell align="right">{row.validUntilDate}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    render() {
        return (
            <>
                <h3>Eddigi megnevezések</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Név</TableCell>
                                <TableCell align="right">Érvényes -től</TableCell>
                                <TableCell align="right">Érvényes -ig</TableCell>
                            </TableRow>
                        </TableHead>
                        {this.getBody()}
                    </Table>
                </TableContainer>
                <h3>Új megnevezés</h3>
                <form onSubmit={this.handleSubmit}>
                    <div className='flex-form'>
                        <div className='input-group'>
                            <ErrorAwareTextField
                                name="name"
                                label="Új név"
                                errors={this.state.errors}
                                value={this.state.name}
                                onChange={e => this.handleNameChange(e, this)} />
                        </div>
                        <div className='input-group'>
                            <ErrorAwareDatePicker
                                name="validFrom"
                                label="Érvényesség kezdete"
                                errors={this.state.errors}
                                value={this.state.validFrom}
                                minDate={this.getMinDate()}
                                onChange={event => this.handleValidUntilChange(event)} />
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                            Mégse
                        </Button>
                        <Button className="btn-submit" variant="contained" color="primary" type="submit">
                            Mentés
                        </Button>
                    </div>
                </form>
            </>
        )
    }
}

export default withSnackbar(Name);
